import { Loader } from "@tandemdiabetes/sugarmate-react-components"

import styles from "./OverlayLoader.module.scss"

interface Props {
  visible?: boolean;
}

export const OverlayLoader = (props: Props) => {
  const { visible = false } = props

  return visible ? (
    <div className={styles.overlayLoaderWrapper}>
      <Loader />
    </div>
  ) : null
}
